export default __webpack_public_path__ + "static/media/AiVoiceAnimation.42718d80.gif";